import React from 'react';
import toast from 'react-hot-toast';
import { CreatePimsConfigFormProps } from './types';
import { createPimsConfigSchema, createPimsConfigFields } from './schema';
import type { CreatePimsConfigFormValues } from './schema';
import { Modal, SchemaForm } from '@v2/components';
import { useCreatePimsConfig } from '@v2/hooks';

const CreatePimsConfigForm: React.FC<CreatePimsConfigFormProps> = ({
  isOpen,
  onClose,
  pimsId,
  onSuccess,
}) => {
  const { createConfig, loading, error: createError } = useCreatePimsConfig();

  const handleSubmit = async (data: CreatePimsConfigFormValues): Promise<void> => {
    try {
      await createConfig({
        entityId: pimsId,
        entityType: 'Pims',
        key: data.key,
        value: data.value || null,
      });
      toast.success('Configuration created successfully');
      onSuccess?.();
      onClose();
    } catch {
      toast.error(createError ?? 'Failed to create configuration');
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Create Configuration" size="md">
      <SchemaForm
        fields={createPimsConfigFields}
        schema={createPimsConfigSchema}
        onSubmit={handleSubmit}
        loading={loading}
        error={createError}
        submitLabel="Create"
        onCancel={onClose}
        cancelLabel="Cancel"
      />
    </Modal>
  );
};

export { CreatePimsConfigForm };
export default CreatePimsConfigForm;
